module.exports = __webpack_public_path__ + "img/1000-2_SERF_2022_Samuel-Icon.015027de.png";